const updateDotsPosition = () => {
    const slickDots = document.querySelector('#topPicksCarousel .slick-dots');
    let marginWidth = 8;

    if (window.bf20.deviceType === 'desktop') {
        marginWidth = 0;
    }

    if (slickDots) {
      const slickDotsWidth = slickDots.clientWidth;      
      //const sliderTargetWidth = document.getElementById('topPicksCarousel').clientWidth;
      
      const leftPos = slickDotsWidth / 2; //(sliderTargetWidth / 2) + marginWidth - (slickDotsWidth / 2) ;
      slickDots.style.left = `calc(50% - ${leftPos}px`;
    }
}

const initialiseSlider = () => {
    let arrows = false;
    let dots = true;
    let slidesToShow = 3;
    let slidesToScroll = 3;

    if (window.bf20.deviceType === "desktop") {
        arrows = true;
        slidesToShow = 5;
        slidesToScroll = 5;
    }
    
    $sd('#topPicksCarousel').slick({
        autoplay: true,           
        arrows: arrows,
        dots: dots,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        infinite: true,
        swipe: true
    });
      
    
    if (window.location.href.indexOf('littlewoods.') !== -1) {
        document.getElementById('sliderTarget-homeTopPicksCarousel').classList.add('lw');
    }
    if (window.location.href.indexOf('littlewoodsireland.') !== -1) {
        document.getElementById('sliderTarget-homeTopPicksCarousel').classList.add('lwi');
    }
    if (window.location.href.indexOf('very.ie') !== -1) {
        // Use the default styling - i.e. as for Very
    }

    //updateDotsPosition();
}

export default initialiseSlider;